import { render, staticRenderFns } from "./ProfileStatusForm.vue?vue&type=template&id=de7ca280&"
import script from "./ProfileStatusForm.vue?vue&type=script&lang=ts&"
export * from "./ProfileStatusForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports